import React, { useState } from 'react';
import {Card, Typography, List, Avatar, Row, Col, Divider, Modal, Spin, Input} from 'antd';
import {DeleteOutlined, EditOutlined, UserOutlined} from '@ant-design/icons';
import axios from "axios";
import {DEFAULT_URL} from "../../constants";
import apiService from "../../api";

const { Meta } = Card;

interface CardUiProps {
    items: any[] ;
    title: string;
    editFunction?:()=>void;
    deleteFunction?:()=>void;
}

const SAVED_REPORTS = 'Custom made reports';

const CardUi: React.FC< CardUiProps> = ({
  title,
  items = [],
}) => {
  const [hoveredItem, setHoveredItem] = useState<number | string | null>(null);
  const [hoveredReport, setHoveredReport] = useState<string | null>(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [operationReport, setOperationReport] = useState<string | null>(null);
  const [newReportName, setNewReportName] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleRemoveOk = async () => {
      try {
          await axios({
              method: 'delete',
              data: {
                  report_name: operationReport,
                  },
              url: `${DEFAULT_URL}remove_report`,
              headers: {
                  'Content-Type': 'application/json',
              },
              withCredentials: true,
          });
          console.log(hoveredReport);
      } catch (error) {
          console.error(error);
      } finally {
          window.location.reload()
          handleModalClose();
      }
  }

    const handleEditOk = async () => {
        try {
            await axios({
                method: 'put',
                data: {
                    report_name: operationReport,
                    new_name: newReportName,
                },
                url: `${DEFAULT_URL}set_report_name`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            });
            console.log(hoveredReport);
        } catch (error) {
            console.error(error);
        } finally {
            window.location.reload()
            handleModalClose();
        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewReportName(e.target.value);
    };

    const handleModalClose = () => {
        setOperationReport(null);
        setIsEditModalVisible(false);
        setIsDeleteModalVisible(false);
    }
  return (

      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      <Card
        hoverable
        style={{
            marginLeft: '15%',
            width: '70%',
            backgroundColor: 'rgb(253, 247, 237)',
            borderRadius: '15px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            marginBottom: '20px',
            maxWidth:'100%',
            cursor: 'default'
        }}
      >
        <div
          style={{
            justifyContent: 'center',

            marginBottom: '20px',
          }}
        >

        </div>
        <Meta
          title={
            <>              <Divider>

            <h3 style={{ fontSize: '25px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(3 55 120)', letterSpacing: '0.5px', textAlign:'center' }}>{title}</h3>
              </Divider>
            </>
          }
        />
        <List
          itemLayout="horizontal"
          dataSource={items}
          style={{
              textAlign:'center',
              alignItems: 'center',
              justifyContent: 'center',
          }}
          renderItem={(reportItem, index) => (<div style={{display: 'flex', alignItems: 'center'}}>
                  <div
                      style={{
                          display: 'flex',
                          margin: '10px 0',
                          backgroundColor: hoveredItem === index ? 'rgb(146, 182, 204)' : '#fff',
                          padding: '15px',
                          borderRadius: '10px',
                          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                          transition: 'background-color 0.3s ease',
                          cursor: 'pointer',
                          maxWidth: '80%',
                          width: '50%',
                          minWidth: '35%'
                      }}
                      onMouseEnter={() => setHoveredItem(index)}
                      onMouseLeave={() => setHoveredItem(null)}
                  >

                      <Modal
                          title="Are you sure?"
                          visible={isDeleteModalVisible}
                          onOk={handleRemoveOk}
                          onCancel={handleModalClose}
                          okText="Yes"
                          cancelText="No"
                          maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} // Add this line
                      >
                          <p>Are you sure you want to remove this report</p>
                      </Modal>
                      <Modal title="Edit Report name" visible={isEditModalVisible} onOk={handleEditOk} onCancel={handleModalClose}>
                          <Spin spinning={loading}>
                              <p > <span style={{color:'red'}}>*</span> It will override if the report name is already exists</p>
                              <Input placeholder="New report name" value={newReportName||''} onChange={handleInputChange} />
                          </Spin>
                      </Modal>
                      <Typography.Text
                          style={{
                              fontSize: '19px',
                              fontWeight: 'bold',
                              color: hoveredItem === index ? '#fff' : 'rgb(0 74 167)',
                          }}
                      >
                          {reportItem}
                      </Typography.Text>
                  </div>

              <div style={{marginLeft: '30px', pointerEvents: title === SAVED_REPORTS? 'auto':'none'}} >
                      <EditOutlined
                          style={{ marginRight: '20px', fontSize:'18px', color: title === SAVED_REPORTS?hoveredItem === 'EditOutlined'+index ? '#0d6efd' : 'black':'#ccc' }}
                          onMouseEnter={() => {setHoveredItem('EditOutlined'+index);setHoveredReport(reportItem?.props?.children);}}
                          onMouseLeave={() => {setHoveredItem(null);  setHoveredReport(null);}}
                          onClick={()=>{title ===SAVED_REPORTS&&setOperationReport(reportItem?.props?.children); setIsEditModalVisible(true)}}
                      />
                      <DeleteOutlined
                          style={{ marginRight: '20px', fontSize:'18px', color: title === SAVED_REPORTS?hoveredItem === 'DeleteOutlined'+index ? 'red' : 'black':'#ccc' }}
                          onMouseEnter={() => {setHoveredItem('DeleteOutlined'+index); setHoveredReport(reportItem?.props?.children);}}
                          onMouseLeave={() => {setHoveredItem(null); setHoveredReport(null);}}
                          onClick={()=>{title ===SAVED_REPORTS&&setOperationReport(reportItem?.props?.children)
                          ;console.log(reportItem?.props?.children);
                          setIsDeleteModalVisible(true)}}
                      />
                  </div>
              </div>
          )}
        />
      </Card>
      </Col>
  );
};

export default CardUi;
